import React, { useState, useEffect,useRef } from "react";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CancelIcon from "@material-ui/icons/Cancel";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import http from "../Common/RestAPIHandler";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
// import HTMLEditor from "./HTMLEditor";
import MyComponent from "./RichTextEditor";
// import { Editor } from '@tinymce/tinymce-react';
// import * as sanitizeHtml from 'sanitize-html';
// import {RichTextContainer, RichTextEditor} from 'bandicoot'
import {objectForm,customizedJson} from "./Languages"

import {
  Avatar,
  FormHelperText,
  Input,
  InputLabel,
  TextField,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  DatePicker,
  TimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ScreenLoader from "./Loader";
import MiniSpinLoader from "./MiniSpinLoader";
import FileViewer from "./FileViewer";
import { Dialog } from "@material-ui/core";
import Slider from "@material-ui/core/Slider";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Popover from "@material-ui/core/Popover";
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import KeyGen from "./KeyGen";
import InputAdornment from "@material-ui/core/InputAdornment";
import DataMappings from "../Company/DataMappings";
import PortalDataMappings from "../ClientPortal/DataMappings";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import useStyles from "./Style/FormStyle";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Blink from 'react-blink-text';

export var temp_status = 0;
export function setTS(prop){
  temp_status = prop;
}

const ObjectForm = (props) => {
  const classes = useStyles();

  const [spin, setSpin] = useState(false);
  const [object, setObject] = useState({});
  const [html, setHtml] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loadData, setLoadData] = useState(false);
  const [objectId] = useState(props.objectId);
  const [filePath, setFilePath] = useState();
  const [isHidden, setIsHidden] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataMappings, setDataMappings] = useState([]);
  const [isInvalidDate, setIsInvalidDate] = useState(false);
  const [ready,setReady] = useState(false);
  const [change,setChange] = useState({});
  const [changeKey,setChangeKey] = useState({});
  // control the confirmation of changing the customized schema
  const [confirmChange, setConfirmChange] = useState(false);

  // const log = () => {
  //   if (editorRef.current) {
  //     console.log(editorRef.current.getContent());
  //   }
  // };
  var skipFields = [];
  const formFields = props.formFields;

  const rawLang = localStorage.getItem("languages");
  const lang = (rawLang !== null && !isNaN(rawLang) && parseInt(rawLang) >= 0 && parseInt(rawLang) <= 2) ? parseInt(rawLang) : 0;

  useEffect(()=>{
    if (ready===0){
      temp_status = 0
    }
    else if(ready===1){
      temp_status = 1
    }

  },[ready])

  useEffect(() => {
    if (Object.keys(html).length > 0) {
      setObject(prevObject => ({
        ...prevObject,
        ...html,
      }));
    }
  }, [html]);

  useEffect(() => {
    if (objectId) {
      setLoadData(true);
      http.Get(
        `${props.url}/${objectId}`,
        (object) => {
          if (props.object) {
            setObject({ ...props.object, ...object });
          } else {
            setObject(object);
          }
          http.Get(
            `data_mappings?from_id=${objectId}`,
            (data) => {
              console.log(data);
              setDataMappings(data);

              setLoadData(false);
            },
            () => {
              setLoadData(false);
            }
          );
        },
        (err) => {
          console.log(err);
          setLoadData(false);
        }
      );
	} else if (props.object) {
      setObject(props.object);
      setLoadData(false);
    } else {
      setObject({});
      setLoadData(false);
    }
  }, [objectId, props.object, props.url]);

  const onChange = (e) => {
    if (e.target) {
      if ("checkbox" === e.target.type || "radio" === e.target.type) {
        setObject({
          ...object,
          [e.target.name]: !object[e.target.name],
        });
      } else if ("file" === e.target.type) {
        setObject({
          ...object,
          [e.target.name]: e.target.files[0],
        });
      } else {
          setObject({
            ...object,
            [e.target.name]: e.target.value,
          });
        }
      }

    setIsSubmitted(false);
  };

  const onChangeInt = (e) => {
    if (e.target) {
          setObject({
            ...object,
            [e.target.name]: e.target.value.replace(/\D/,''),
          });
        }
    setIsSubmitted(false);
  };

  const onSubmit = (e) => {
    setReady(true)
		if (props.setAlertOpen) {
			props.setObj(object);
			props.setAlertOpen(true);
			return;
		}

    if (object.passphrase === ""){
      delete object.passphrase;
    }

		e.preventDefault();
		let data = false;
    if (props.preSubmit) {
      let processedData = props.preSubmit(object);
			data = {
				...object,
				...processedData
			};
    }

    setLoadData(true);
    skipFields.map((skipField) => {
      object[skipField] = undefined;
      return skipField;
    });
		console.log(data);
    setIsSubmitted(true);

    if (objectId) {
      http.Post(
        `${props.url}/pre/${objectId}`,
        data ? data : object,
        () => {
          console.log("--------------------------")
          props.closeOpen(false)
        }
      )
      http.Put(
        `${props.url}/${objectId}`,
        data ? data : object,
        (object) => {
          http.Delete(
            "data_mappings",
            { from_id: objectId },
            () => {
              var promises = dataMappings.map((dataMapping) => {
                dataMapping.from_id = object.id;
                return http.Post(
                  "data_mappings",
                  dataMapping,
                  (data) => {
                    console.log(data);
                  },
                  (status, error) => {
                    console.log(status);
                    console.log(error);
                  }
                );
              });
              Promise.all(promises).then((results) => {
                props.handleObjectSubmit();
                setLoadData(false);
              });
            },
            () => {
              props.handleObjectSubmit();
              setLoadData(false);
            }
          );
        },
        (status, error) => {
          setLoadData(false);
          setErrors(error);
          setIsSubmitted(false);
          if (error["__all__"]) {
            alert(error["__all__"]);
          }
          if (error["non_field_errors"]) {
            alert(error["non_field_errors"]);
          }
        }
      );
    } else {
      http.Post(
        `${props.url}`,
        data ? data : object,
        (newObject) => {
          var promises = dataMappings.map((dataMapping) => {
            dataMapping.from_id = newObject.id;
            return http.Post(
              "data_mappings",
              dataMapping,
              (data) => {
                console.log(data);
              },
              (status, error) => {
                console.log(status);
                console.log(error);
              }
            );
          });
          Promise.all(promises).then((results) => {
            if (object.subDatas && object.subDatas.length > 0) {
              var promises = object.subDatas.map((subData) => {
                if (subData.data instanceof FormData) {
                  subData.data.append(subData.id, newObject.id);
                } else {
                  subData.data[subData.id] = newObject.id;
                }
                return http.Post(
                  subData.url,
                  subData.data,
                  (data) => {
                    console.log(data);
                  },
                  (status, error) => {
                    console.log(status);
                    console.log(error);
                  }
                );
              });
              Promise.all(promises).then((results) => {
                props.handleObjectSubmit();
                setLoadData(false);
              });
            } else {
              props.handleObjectSubmit();
              setLoadData(false);
            }
          });
        },
        (status, error) => {
          setLoadData(false);
          setErrors(error);
          setIsSubmitted(false);
          if (error["__all__"]) {
            alert(error["__all__"]);
          }
          if (error["non_field_errors"]) {
            alert(error["non_field_errors"]);
          }
        }
      );
    }
  };

  return (

    <div id="web">


      {filePath && (
        <Dialog
          fullWidth
          maxWidth="md"
          open={true}
          onClose={() => {
            setFilePath(null);
          }}
        >
          <FileViewer
            fileType={filePath.fileType.toLowerCase()}
            filePath={filePath.filePath}
            onError={() => {
              setFilePath(null);
            }}
          />
        </Dialog>
      )}

      <div className={classes.header}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={8}>
            <Typography variant="h6" component="h6" className={classes.title}>
              {objectId ? objectForm.Edit[lang] : objectForm.AddNew[lang]} {props.formName}
            </Typography>
          </Grid>
          <Grid item xs={4} className={classes.gridItem}>
            <IconButton
              className={classes.iconButtonColored}
              onClick={() => props.closeOpen(false)}
            >
              <HighlightOffIcon />
            </IconButton>
          </Grid>
        </Grid>
      </div>

      <Divider />
      {loadData && <ScreenLoader />}

      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ValidatorForm onSubmit={onSubmit}>
          <div className={classes.content}>
            <div style={{ display: loadData ? "none" : "block" }}>
              {loadData && <ScreenLoader />}


              {formFields.map((field) => {
                if (field.type === "text") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <TextValidator
                        id={field.id}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        name={field.id}
                        value={object[field.id] || ""}
                        onChange={onChange}
                        onBlur={(e) => {
                          if (field.onBlur) {
                            field.onBlur(e, object, setObject, setErrors);
                          }
                        }}
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "integer") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <TextValidator
                        id={field.id}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        name={field.id}
                        value={object[field.id]}
                        onChange={onChangeInt}
                        onBlur={(e) => {
                          if (field.onBlur) {
                            field.onBlur(e, object, setObject, setErrors);
                          }
                        }}
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                }else if (field.type === "autocomplete") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      {object[field.id] && (
                        <Autocomplete
                          id={field.id}
                          multiple
                          filterSelectedOptions
                          classes={{
                            option: classes.option,
                            popper: classes.popper,
                          }}
                          options={field.valueMap}
                          defaultValue={object[field.id]}
                          // ^^^ Need to render selected users (guests) from object in state pulled from DB
                          getOptionLabel={(option) => {
                            if (option.first_name) {
                              return option.first_name + " " + option.last_name;
                            } else if (option.role_name) {
                              return option.role_name;
                            }
                          }}
                          renderOption={(option) => {
                            if (option.first_name) {
                              return (
                                <>
                                  <span>
                                    {option.profile_image_src ? (
                                      <Avatar
                                        className={classes.smallAvatar}
                                        alt={option.first_name}
                                        src={option.profile_image_src}
                                      />
                                    ) : (
                                      <AccountCircleIcon
                                        fontSize="large"
                                        color="action"
                                      />
                                    )}
                                  </span>
                                  <span>
                                    <div style={{ fontWeight: 400 }}>
                                      {option.first_name +
                                        " " +
                                        option.last_name}
                                    </div>
                                    <div
                                      style={{ fontWeight: 350, fontSize: 13 }}
                                    >
                                      {option.email}
                                    </div>
                                  </span>
                                </>
                              );
                            } else if (option.role_name) {
                              return <span>{option.role_name}</span>;
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              fullWidth
                              margin="dense"
                              placeholder={
                                object[field.id] &&
                                object[field.id].length === 0 &&
                                field.placeholder
                              }
                            />
                          )}
                          onChange={
                            field.onChange
                              ? (e, value) => field.onChange(e, value, object, setObject)
                              : (e, value) => {
                                  setObject({
                                    ...object,
                                    [field.id]: value,
                                  });
                                }
                          }
                        />
                      )}
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "password" ) {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <TextValidator
                        id={field.id}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        type={isHidden ? "password" : "text"}
                        name={field.id}
                        value={object[field.id] || ""}
                        onChange={onChange}
                        onBlur={(e) => {
                          if (field.onBlur) {
                            field.onBlur(e, object, setObject, setErrors);
                          }
                        }}
                        InputProps={{
                          style: { fontFamily: "Raleway" },
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => {
                                  setIsHidden(!isHidden);
                                }}
                              >
                                {isHidden ? (
                                  <VisibilityOff className={classes.disabled} />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                              <IconButton
                                aria-label="KeyGen"
                                onClick={(e) => {
                                  setAnchorEl(e.currentTarget);
                                }}
                              >
                                <FingerprintIcon />
                              </IconButton>
                              <Popover
                                open={Boolean(anchorEl)}
                                anchorEl={anchorEl}
                                onClose={(e) => {
                                  setAnchorEl(null);
                                }}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                              >
                                <KeyGen
                                  setPassword={(p) => {
                                    setObject({
                                      ...object,
                                      [field.id]: p,
                                    });
                                    setAnchorEl(null);
                                  }}
                                />
                              </Popover>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "slider") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <Slider
                        name={field.id}
                        value={object[field.id] || 0}
                        min={field.min}
                        max={field.max}
                        onChange={(event, newValue) => {
                          setObject({
                            ...object,
                            [field.id]: newValue,
                          });
                        }}
                      />
                      <span style={{ float: "right" }}>
                        {object[field.id] || 0}
                      </span>
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "readonly") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <TextValidator
                        id={field.id}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        name={field.id}
                        value={object[field.id] || ""}
                        onChange={onChange}
                        onBlur={(e) => {
                          if (field.onBlur) {
                            field.onBlur(e, object, setObject, setErrors);
                          }
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "divider") {
                  return (
                    <Divider />
                  );
                }else if (field.type === "textarea") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <TextValidator
                        id={field.id}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        multiline
                        rows={4}
                        name={field.id}
                        value={object[field.id] || ""}
                        onChange={onChange}
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "radio" && field.id !== "is_hidden") {
                  return (
                    <div key={field.id}>
                      <FormControlLabel
                        control={
                          <Radio
                            name={field.id}
                            checked={object[field.id] ? true : false}
                            onClick={(e) => {
                              field.onChange
                                ? field.onChange(
                                    e,
                                    object,
                                    setObject,
                                    setErrors
                                  )
                                : onChange(e);
                            }}
                          />
                        }
                        label={field.label}
                        labelPlacement="end"
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (
                  field.type === "radio" &&
                  field.id === "is_hidden" &&
                  !field.hide
                ) {
                  return (
                    <div key={field.id}>
                      <FormControlLabel
                        control={
                          <Radio
                            name={field.id}
                            checked={object[field.id] ? true : false}
                            onClick={(e) => {
                              field.onChange
                                ? field.onChange(
                                    e,
                                    object,
                                    setObject,
                                    setErrors
                                  )
                                : onChange(e);
                            }}
                          />
                        }
                        label={field.label}
                        labelPlacement="end"
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "display") {
                                  return (
                                    <div key={field.id}>
                                      <Typography variant="subtitle2" style={{marginTop: 16, marginBottom: 8}}>
                                        {field.label}
                                      </Typography>
                                      <Typography variant="body1">
                                        {field.getValue ? field.getValue(object) : (object[field.id] || "N/A")}
                                      </Typography>
                                    </div>
                                  );
				} else if (field.type === "select") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <Select
                        id={field.id}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        name={field.id}
                        value={object[field.id] != null ? object[field.id] : ""}
                        onChange={(e) => {
                          field.onChange
                            ? field.onChange(e, object, setObject, setErrors)
                            : onChange(e);
                        }}
                      >
                        {Object.entries(field.valueMap).map(([key, value]) => (
                          <MenuItem key={key} value={key}>
                            {value}
                          </MenuItem>
                        ))}
                      </Select>
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "multiselect") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <Select
                        id={field.id}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        name={field.id}
                        value={object[field.id] != null ? object[field.id] : ""}
                        onChange={(e) => {
                          field.onChange
                            ? field.onChange(e, object, setObject, setErrors)
                            : onChange(e);
                        }}
                      >
                        {Object.entries(field.valueMap).map(([key, value]) => {
                          if (
                            !Array.isArray(object[field.id]) ||
                            !object[field.id].includes(key)
                          ) {
                            return (
                              <MenuItem key={key} value={key}>
                                {value}
                              </MenuItem>
                            );
                          }
                        })}
                      </Select>
                      <p className={classes.error}>{errors[field.id]}</p>
                      {field.selectedValues &&
                        field.selectedValues.map((value) => {
                          return (
                            <p>
                              {field.onClick ? (
                                <span
                                  className={`${classes.link} ${classes.spacingLH}`}
                                  onClick={(e) => {
                                    field.onClick(
                                      e,
                                      object,
                                      setObject,
                                      setErrors,
                                      value["value"]
                                    );
                                  }}
                                >
                                  {value["label"]}
                                </span>
                              ) : (
                                value["label"]
                              )}

                              <Button
                                className={classes.iconButtonColored}
                                onClick={(e) => {
                                  value.onDelete(
                                    e,
                                    object,
                                    setObject,
                                    setErrors
                                  );
                                }}
                              >
                                <HighlightOffIcon />
                              </Button>
                            </p>
                          );
                        })}

                      {!field.selectedValues &&
                        Array.isArray(object[field.id]) &&
                        object[field.id].map((value) => {
                          if (value)
                            return (
                              <p>
                                {field.valueMap[value]}
                                <Button
                                  className={classes.iconButtonColored}
                                  onClick={(e) => {
                                    field.deleteValue(
                                      e,
                                      object,
                                      setObject,
                                      setErrors,
                                      value
                                    );
                                  }}
                                >
                                  <HighlightOffIcon />
                                </Button>
                              </p>
                            );
                        })}
                    </div>
                  );
                } else if (field.type === "file" && object.id) {
                  skipFields.push(field.id);
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <a href={object[field.id]} target="_blank" rel="noopener noreferrer">
                        {object[field.id]}
                      </a>
                      <Input
                        className={classes.fileUpload}
                        type="file"
                        name={field.id}
                        onChange={(e) => {
                          field.onChange
                            ? field.onChange(e, object, setObject, setErrors)
                            : onChange(e);
                        }}
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "image" && object.id) {
                  skipFields.push(field.id);
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      {object[field.id + "_src"] && (
                        <>
                          <img
                            style={{ maxWidth: "200px", maxHeigth: "200px" }}
                            alt={field.id}
                            src={object[field.id + "_src"]}
                          />
                          <Button
                            onClick={(e) => {
                              field.onDelete(e, object, setObject, setErrors);
                            }}
                          >
                            <CancelIcon />
                          </Button>
                        </>
                      )}
                      <br />
                      <Input
                        className={classes.fileUpload}
                        type="file"
                        name={field.id}
                        fullWidth
                        disableUnderline
                        onChange={(e) => {
                          field.onChange
                            ? field.onChange(e, object, setObject, setErrors)
                            : onChange(e);
                        }}
                        inputProps={{
                          accept: "image/png, image/jpeg, image/jpg",
                        }}
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "icon" && object.id) {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      {object[field.id] && (
                        <>
                          <img
                            style={{ maxWidth: "20px", maxHeigth: "20px" }}
                            alt={field.id}
                            src={object[field.id]}
                          />
                        </>
                      )}
                      <br />
                      <Input
                        className={classes.fileUpload}
                        type="file"
                        name={field.id}
                        fullWidth
                        disableUnderline
                        onChange={(e) => {
                          field.onChange
                            ? field.onChange(e, object, setObject, setErrors)
                            : onChange(e);
                        }}
                        inputProps={{
                          accept: "image/png, image/x-icon,",
                        }}
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "files") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <div className={classes.containerRow}>
                        <Input
                          id={field.id}
                          type="file"
                          name={field.id}
                          startAdornment={
                            <InputLabel for={field.id} className={classes.w100}>
                              Click to upload...
                            </InputLabel>
                          }
                          className={
                            errors[field.id]
                              ? `${classes.fileUpload} ${classes.error}`
                              : classes.fileUpload
                          }
                          aria-describedby="my-upload"
                          inputProps={{ style: { visibility: "hidden" } }}
                          onChange={(e) => {
                            field.onChange
                              ? field.onChange(
                                  e,
                                  object,
                                  setObject,
                                  setErrors,
                                  setSpin
                                )
                              : onChange(e);
                          }}
                          endAdornment={spin && spin ? <MiniSpinLoader /> : ""}
                        />
                      </div>
                      <FormHelperText
                        id="my-upload"
                        className={classes.errorHelper}
                      >
                        {" "}
                        {errors[field.id]}
                      </FormHelperText>
                      {field.files.map((file) => {
                        if (file.file)
                          return (
                            <p key={file.id}>
                              <span
                                className={`${classes.link} ${classes.spacingLH}`}
                                onClick={() => {
                                  if (file.file_src) {
                                    setFilePath({
                                      filePath: file.file_src,
                                      fileType: file.file
                                        .split("?")[0]
                                        .split(".")
                                        .pop(),
                                    });
                                  } else {
                                    alert("File Not Found!");
                                  }
                                }}
                              >
                                {file.name}
                              </span>
                              <Button
                                className={classes.iconButtonColored}
                                onClick={() => {
                                  file.onDelete(file.id);
                                }}
                              >
                                <HighlightOffIcon />
                              </Button>
                            </p>
                          );
                        else
                          return (
                            <p key={file.id}>
                              {file.name}
                              <Button
                                onClick={() => {
                                  file.onDelete(file.name);
                                }}
                              >
                                <CancelIcon />
                              </Button>
                            </p>
                          );
                      })}
                    </div>
                  );
                } else if (field.type === "email") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <TextValidator
                        id={field.id}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        name={field.id}
                        value={object[field.id] || ""}
                        onChange={(e) => {
                          field.onChange
                            ? field.onChange(e, object, setObject, setErrors)
                            : onChange(e);
                        }}
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "ckeditor") {
                  return (
                    <div key={field.id} className={classes.editor}>
                      <p className={classes.label}>{field.label}</p>
                      {object[field.id] !== undefined && (
                          // <Editor
                          //   initialValue={editor}
                          //   value={editor}
                          //   onEditorChange={(newValue, editor) => setEditor({
                          //     newValue
                          //   })}
                          // />

                        // <Editor
                        //   apiKey='your-api-key'
                        //   onInit={(evt, editor) => editorRef.current = editor}
                        //   initialValue="<p>This is the initial content of the editor.</p>"
                        //   init={{
                        //     height: 500,
                        //     menubar: false,
                        //     plugins: [
                        //       'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                        //       'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                        //       'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                        //     ],
                        //     toolbar: 'undo redo | blocks | ' +
                        //       'bold italic forecolor | alignleft aligncenter ' +
                        //       'alignright alignjustify | bullist numlist outdent indent | ' +
                        //       'removeformat | help',
                        //     content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        //   }}
                        // />
                        /////////////////////////////////////Tiny Editor has a 1000 limitation for free tier//////////
                        // <MyComponent {...props} initialValue={object.content || ""} onChange={(data) => {
                        //   setHtml({
                        //     [field.id]: data,
                        //   });
                        // }} ready = {ready}
                        // />
                        /////////////////////Switch to another rich text editor which has a MIT license///////////////
                        //https://github.com/nib-edit/nib
                        // <MyEditor initialValue= {object.content} onChange={(data) => {
                        //     setHtml({
                        //       [field.id]: data,
                        //     });
                        //   }}/>
                        // <HTMLEditor
                        //   {...props}
                        //   name={field.id}
                        //   value={object[field.id]}
                        //   onChange={(data) => {
                        //     setHtml({
                        //       [field.id]: data,
                        //     });
                        //   }}
                        //   className="htmlEditor"
                        // />
                        <MyComponent
                            {...props}
                            default = {object.content || ""}
                            onChange={(data) => {
                              setHtml({
                                [field.id]: data,
                              });
                            }}/>

                      )}

                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "dataMapping") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      {props.user.user_type === "Tenant User" ? (
                        <DataMappings
                          {...props}
                          fromId={objectId}
                          fromModel={field.model}
                          dataMappings={dataMappings}
                          setDataMappings={setDataMappings}
                        />
                      ) : (
                        <PortalDataMappings
                          {...props}
                          fromId={objectId}
                          fromModel={field.model}
                          dataMappings={dataMappings}
                          setDataMappings={setDataMappings}
                        />
                      )}
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "date") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <KeyboardDatePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        margin="dense"
                        inputVariant="outlined"
                        format="yyyy-MM-dd"
                        fullWidth
                        value={
                          object[field.id] &&
                          new Date(
                            new Date(object[field.id]).getTime() +
                              new Date(object[field.id]).getTimezoneOffset() *
                                60 *
                                1000
                          )
                        }
                        onChange={(value) => {
                          if (value && String(value) !== "Invalid Date") {
                            setObject({
                              ...object,
                              [field.id]: value.toISOString().split("T")[0],
                            });
                          } else {
                            setObject({
                              ...object,
                              [field.id]: value,
                            });
                          }
                        }}
                      />
                      <p className={classes.error}>{errors[field.id]}</p>
                    </div>
                  );
                } else if (field.type === "dateTime") {
                  return (
                    <div key={field.id}>
                      <p className={classes.label}>{field.label}</p>
                      <Grid container alignItems="center" spacing={1}>
                        <Grid item xs={5}>
                          <DatePicker
                            autoOk
                            disableToolbar
                            variant="inline"
                            inputVariant="outlined"
                            format="MMM dd, yyyy"
                            fullWidth
                            color="inherit"
                            margin="dense"
                            value={object[field.id]}
                            onChange={(value) => {
                              if (value && String(value) !== "Invalid Date") {
                                setObject({
                                  ...object,
                                  [field.id]: value,
                                });
                                setIsInvalidDate(false);
                              } else {
                                setObject({
                                  ...object,
                                  [field.id]: value,
                                });
                                setIsInvalidDate(true);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={5}>
                          <TimePicker
                            autoOk
                            ampm
                            variant="inline"
                            inputVariant="outlined"
                            format="hh:mm a"
                            fullWidth
                            margin="dense"
                            value={object[field.id]}
                            onChange={(value) => {
                              if (value && String(value) !== "Invalid Date") {
                                setObject({
                                  ...object,
                                  [field.id]: value,
                                });
                                setIsInvalidDate(false);
                              } else {
                                setObject({
                                  ...object,
                                  [field.id]: value,
                                });
                                setIsInvalidDate(true);
                              }
                            }}
                          />
                        </Grid>
                      </Grid>
                      {isInvalidDate && (
                        <Grid item container spacing={1}>
                          <Grid item xs={3}></Grid>
                          <Grid item xs={9}>
                            <p style={{ color: "red" }}>
                              Invalid Meeting time.
                            </p>
                          </Grid>
                        </Grid>
                      )}
                    </div>
                  );
                } else if (field.type === "json") {
                  var json_data = {};
                  try {
                    if (object[field.id]) {
                      json_data = JSON.parse(object[field.id]);
                    }
                  } catch (err) {
                    console.log(err);
                  }
                  let json_schema = {};
                  try {
                    json_schema = JSON.parse(field.schema);
                  } catch (err) {
                    console.log(err);
                  }
                  return (
                    <div key={field.id}>
                      {json_schema.properties &&
                        Object.entries(json_schema.properties).map(
                          ([key, property]) => {
                            return (
                              <div>
                                <p className={classes.label}>
                                  {!property.required ? key : key + " *"}
                                </p>
                                {["text", "number", "email", "url"].includes(
                                  property.type
                                ) && (
                                  <TextValidator
                                    id={field.id}
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    type={property.type}
                                    name={field.id}
                                    required={property.required}
                                    value={
                                      object[field.id]
                                        ? JSON.parse(object[field.id])[key]
                                        : ""
                                    }
                                    onChange={(e) => {
                                      json_data[key] = e.target.value;
                                      var keyWords = "";
                                      Object.entries(
                                        json_schema.properties
                                      ).map(([key, property]) => {
                                        if (property.searchable) {
                                          keyWords =
                                            keyWords + json_data[key] + ",";
                                        }
                                        return property;
                                      });
                                      setObject({
                                        ...object,
                                        [field.id]: JSON.stringify(
                                          json_data,
                                          null,
                                          " "
                                        ),
                                        searchable: keyWords,
                                      });
                                    }}
                                  />
                                )}
                                {property.type === "textarea" && (
                                  <TextValidator
                                    id={field.id}
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    multiline={true}
                                    rows={4}
                                    type={property.type}
                                    name={field.id}
                                    required={property.required}
                                    value={
                                      object[field.id]
                                        ? JSON.parse(object[field.id])[key]
                                        : ""
                                    }
                                    onChange={(e) => {
                                      json_data[key] = e.target.value;
                                      var keyWords = "";
                                      Object.entries(
                                        json_schema.properties
                                      ).map(([key, property]) => {
                                        if (property.searchable) {
                                          keyWords =
                                            keyWords + json_data[key] + ",";
                                        }
                                        return property;
                                      });
                                      setObject({
                                        ...object,
                                        [field.id]: JSON.stringify(
                                          json_data,
                                          null,
                                          " "
                                        ),
                                        searchable: keyWords,
                                      });
                                    }}
                                  />
                                )}
                                {property.type === "boolean" && (
                                  <FormControlLabel
                                    control={
                                      <Radio
                                        name={field.id}
                                        checked={
                                          object[field.id] &&
                                          JSON.parse(object[field.id])[key]
                                            ? true
                                            : false
                                        }
                                        onClick={(e) => {
                                          json_data[key] = !json_data[key];
                                          var keyWords = "";
                                          Object.entries(
                                            json_schema.properties
                                          ).map(([key, property]) => {
                                            if (property.searchable) {
                                              keyWords =
                                                keyWords + json_data[key] + ",";
                                            }
                                            return property;
                                          });
                                          setObject({
                                            ...object,
                                            [field.id]: JSON.stringify(
                                              json_data,
                                              null,
                                              " "
                                            ),
                                            searchable: keyWords,
                                          });
                                        }}
                                      />
                                    }
                                    labelPlacement="end"
                                  />
                                )}
                                {property.type === "password" && (
                                  <TextValidator
                                    id={field.id}
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    type={isHidden ? "password" : "text"}
                                    name={field.id}
                                    value={
                                      object[field.id]
                                        ? JSON.parse(object[field.id])[key]
                                        : ""
                                    }
                                    onChange={(e) => {
                                      json_data[key] = e.target.value;
                                      var keyWords = "";
                                      Object.entries(
                                        json_schema.properties
                                      ).map(([key, property]) => {
                                        if (property.searchable) {
                                          keyWords =
                                            keyWords + json_data[key] + ",";
                                        }
                                        return property;
                                      });
                                      setObject({
                                        ...object,
                                        [field.id]: JSON.stringify(
                                          json_data,
                                          null,
                                          " "
                                        ),
                                        searchable: keyWords,
                                      });
                                    }}
                                    InputProps={{
                                      style: { fontFamily: "Raleway" },
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => {
                                              setIsHidden(!isHidden);
                                            }}
                                          >
                                            {isHidden ? (
                                              <VisibilityOff
                                                className={classes.disabled}
                                              />
                                            ) : (
                                              <Visibility />
                                            )}
                                          </IconButton>
                                          <IconButton
                                            aria-label="KeyGen"
                                            onClick={(e) => {
                                              setAnchorEl(e.currentTarget);
                                            }}
                                          >
                                            <FingerprintIcon />
                                          </IconButton>
                                          <Popover
                                            open={Boolean(anchorEl)}
                                            anchorEl={anchorEl}
                                            onClose={(e) => {
                                              setAnchorEl(null);
                                            }}
                                            anchorOrigin={{
                                              vertical: "bottom",
                                              horizontal: "center",
                                            }}
                                            transformOrigin={{
                                              vertical: "top",
                                              horizontal: "center",
                                            }}
                                          >
                                            <KeyGen
                                              setPassword={(p) => {
                                                json_data[key] = p;
                                                setObject({
                                                  ...object,
                                                  [field.id]: JSON.stringify(
                                                    json_data,
                                                    null,
                                                    " "
                                                  ),
                                                });
                                                setAnchorEl(null);
                                              }}
                                            />
                                          </Popover>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                )}
                                {![
                                  "text",
                                  "number",
                                  "textarea",
                                  "email",
                                  "url",
                                  "password",
                                  "boolean",
                                ].includes(property.type) && (
                                  <Select
                                    id={field.id}
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    name={field.id}
                                    value={
                                      object[field.id] && JSON.parse(object[field.id])[key] != null
                                        ? JSON.parse(object[field.id])[key]
                                        : ""
                                    }
                                    onChange={(e) => {
                                      json_data[key] = e.target.value;
                                      setObject({
                                        ...object,
                                        [field.id]: JSON.stringify(
                                          json_data,
                                          null,
                                          " "
                                        ),
                                      });
                                    }}
                                  >
                                    {field.categories
                                      .filter((category) => {
                                        return (
                                          category.category_type ===
                                          property.type
                                        );
                                      })
                                      .map((category) => (
                                        <MenuItem
                                          key={category.category_name}
                                          value={category.category_name}
                                        >
                                          {category.category_name}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                )}
                                {errors[field.id] && (
                                  <p className={classes.error}>
                                    {errors[field.id][key]}
                                  </p>
                                )}
                              </div>
                            );
                          }
                        )}
                      {errors[field.id] && Array.isArray(errors[field.id]) && (
                        <p className={classes.error}>{errors[field.id][0]}</p>
                      )}
                    </div>
                  );
                } else if (field.type === "jsonSchema" && object[field.id]) {
                  var json_schema = {
                    type: "object",
                    secured: false,
                    properties: {
                      name: {
                        type: "text",
                        required: true,
                        listed: true,
                        searchable: true,
                        copyable: false,
                      },
                    },
                  };
                  try {
                    json_schema = JSON.parse(object[field.id]);
                  } catch (err) {
                    console.log(err);
                  }
                  return (
                    <div key={field.id}>
                      {/* <p>
                        Secured: &nbsp;&nbsp;&nbsp;&nbsp;
                        <Radio
                          checked={json_schema.secured}
                          onClick={(e) => {
                            json_schema.secured = !json_schema.secured;
                            setObject({
                              ...object,
                              [field.id]: JSON.stringify(
                                json_schema,
                                null,
                                " "
                              ),
                            });
                          }}
                        />
                      </p> */}
                      <Grid container alignItems="center">
                        {object[field.id] &&
                          Object.entries(json_schema.properties).map(
                            ([key, property]) => {
                              return (
                                <>
                                  <Grid item md={12} lg={4}>
                                    <Grid container>
                                      <Grid item xs={3}>
                                        {/* {key}: */}
                                        <TextField
                                          variant="outlined"
                                          fullWidth
                                          margin="dense"
                                          label={customizedJson.Name[lang]}
                                          placeholder={key}
                                          value={changeKey[key]?changeKey[key]:key}
                                          onChange={(e) => {
                                              setChangeKey({
                                                ...changeKey,
                                                [key]: e.target.value,
                                              })
                                              setChange({
                                                ...change,
                                                [key]: e.target.value,
                                              })
                                          }}
                                        />
                                      </Grid>
                                      <Grid item xs={9} style = {{display:"flex",alignItems:"center",flexFlow: "row", paddingLeft:"28px", paddingTop:"4px"}}>
                                        <Select
                                          variant="outlined"
                                          margin="dense"
                                          value={property.type}
                                          onChange={(e) => {
                                            json_schema.properties[key].type =
                                              e.target.value;
                                            setObject({
                                              ...object,
                                              [field.id]: JSON.stringify(
                                                json_schema,
                                                null,
                                                " "
                                              ),
                                            });
                                          }}
                                        >
                                          <MenuItem key={"text"} value={"text"}>
                                            {customizedJson.text[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"number"}
                                            value={"number"}
                                          >
                                            {customizedJson.number[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"textarea"}
                                            value={"textarea"}
                                          >
                                            {customizedJson.textarea[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"password"}
                                            value={"password"}
                                          >
                                            {customizedJson.password[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"email"}
                                            value={"email"}
                                          >
                                            {customizedJson.email[lang]}
                                          </MenuItem>
                                          <MenuItem key={"url"} value={"url"}>
                                            {customizedJson.url[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"boolean"}
                                            value={"boolean"}
                                          >
                                            {customizedJson.boolean[lang]}
                                          </MenuItem>
                                          <Divider />
                                          <MenuItem
                                            key={"category"}
                                            value={"category"}
                                            disabled={true}
                                          >
                                            {customizedJson.Category[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"Industry Type"}
                                            value={"Industry Type"}
                                          >
                                            {customizedJson.IndustryType[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"Device Type"}
                                            value={"Device Type"}
                                          >
                                            {customizedJson.DeviceType[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"Account Type"}
                                            value={"Account Type"}
                                          >
                                            {customizedJson.AccountType[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"Document Category"}
                                            value={"Document Category"}
                                          >
                                            {customizedJson.DocumentCategory[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"Employee Type"}
                                            value={"Employee Type"}
                                          >
                                            {customizedJson.EmployeeType[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"Service Type"}
                                            value={"Service Type"}
                                          >
                                            {customizedJson.ServiceType[lang]}
                                          </MenuItem>
                                          <MenuItem
                                            key={"Credential Type"}
                                            value={"Credential Type"}
                                          >
                                            {customizedJson.CredentialType[lang]}
                                          </MenuItem>
                                        </Select>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item md={12} lg={6}>
                                    <Grid container>
                                      <Grid item xs={3}>
                                        <FormControlLabel
                                          control={
                                            <Radio
                                              checked={
                                                json_schema.properties[key]
                                                  .required
                                              }
                                              onClick={(e) => {
                                                json_schema.properties[
                                                  key
                                                ].required =
                                                  !json_schema.properties[key]
                                                    .required;
                                                setObject({
                                                  ...object,
                                                  [field.id]: JSON.stringify(
                                                    json_schema,
                                                    null,
                                                    " "
                                                  ),
                                                });
                                              }}
                                            />
                                          }
                                          label={customizedJson.Required[lang]}
                                          labelPlacement="end"
                                        />
                                      </Grid>
                                      <Grid item xs={3}>
                                        <FormControlLabel
                                          control={
                                            <Radio
                                              checked={
                                                json_schema.properties[key]
                                                  .listed
                                              }
                                              onClick={(e) => {
                                                json_schema.properties[
                                                  key
                                                ].listed =
                                                  !json_schema.properties[key]
                                                    .listed;
                                                setObject({
                                                  ...object,
                                                  [field.id]: JSON.stringify(
                                                    json_schema,
                                                    null,
                                                    " "
                                                  ),
                                                });
                                              }}
                                            />
                                          }
                                          label={customizedJson.Listed[lang]}
                                          labelPlacement="end"
                                        />
                                      </Grid>
                                      <Grid item xs={3}>
                                        <FormControlLabel
                                          control={
                                            <Radio
                                              checked={
                                                json_schema.properties[key]
                                                  .searchable
                                              }
                                              disabled={json_schema.properties[key].type ==="password"}
                                              onClick={(e) => {
                                                json_schema.properties[
                                                  key
                                                ].searchable =
                                                  !json_schema.properties[key]
                                                    .searchable;
                                                setObject({
                                                  ...object,
                                                  [field.id]: JSON.stringify(
                                                    json_schema,
                                                    null,
                                                    " "
                                                  ),
                                                });
                                              }}
                                            />
                                          }
                                          label={customizedJson.Searchable[lang]}
                                          labelPlacement="end"
                                        />
                                      </Grid>
                                      <Grid item xs={3}>
                                        <FormControlLabel
                                          control={
                                            <Radio
                                              checked={
                                                json_schema.properties[key]
                                                  .copyable
                                              }
                                              onClick={(e) => {
                                                json_schema.properties[
                                                  key
                                                ].copyable =
                                                  !json_schema.properties[key]
                                                    .copyable;
                                                setObject({
                                                  ...object,
                                                  [field.id]: JSON.stringify(
                                                    json_schema,
                                                    null,
                                                    " "
                                                  ),
                                                });
                                              }}
                                            />
                                          }
                                          label={customizedJson.Copyable[lang]}
                                          labelPlacement="end"
                                        />
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item md={12} lg={1}>
                                    <Button
                                      onClick={() => {
                                        delete json_schema.properties[key];
                                        setObject({
                                          ...object,
                                          [field.id]: JSON.stringify(
                                            json_schema,
                                            null,
                                            " "
                                          ),
                                        });
                                      }}
                                    >
                                      <CancelIcon className={classes.iconButtonColored}/>
                                    </Button>
                                  </Grid>
                                  <Grid item md={12} lg={1}>
                                    <Grid container>
                                      <Grid item xs={12}>
                                        <Button
                                          onClick={() => {
                                            var objectEntries = Object.entries(json_schema.properties);
                                            var keyIndex = objectEntries.findIndex(([key1, property1])=>(key1===key));
                                            if(keyIndex > 0){
                                              var newProperties = {};
                                              objectEntries.map(([key1, property1],index) => {
                                                if(index===keyIndex-1){newProperties[key] = property;newProperties[key1] = property1;}
                                                else{newProperties[key1] = property1;}
                                              });
                                              json_schema.properties = newProperties;
                                              setObject({
                                                ...object,
                                                [field.id]: JSON.stringify(
                                                  json_schema,
                                                  null,
                                                  " "
                                                ),
                                              });
                                            }
                                          }}
                                        >
                                          <ExpandLessIcon className={classes.iconButtonColored}/>
                                        </Button>
                                      </Grid>
                                      <Grid item xs={12}>
                                        <Button
                                          onClick={() => {
                                            var objectEntries = Object.entries(json_schema.properties);
                                            var keyIndex = objectEntries.findIndex(([key1, property1])=>(key1===key));
                                            if(keyIndex < (objectEntries.length - 1)){
                                              var newProperties = {};
                                              objectEntries.map(([key1, property1],index) => {
                                                if(index===keyIndex){}
                                                else if(index===(keyIndex + 1)){newProperties[key1] = property1;newProperties[key] = property;}
                                                else{newProperties[key1] = property1;}
                                              });
                                              json_schema.properties = newProperties;
                                              setObject({
                                                ...object,
                                                [field.id]: JSON.stringify(
                                                  json_schema,
                                                  null,
                                                  " "
                                                ),
                                              });
                                            }
                                          }}
                                        >
                                          <ExpandMoreIcon className={classes.iconButtonColored}/>
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </>
                              );
                            }
                          )}
                        <Grid item xs={12}>
                          {errors[field.id] && (
                            <p className={classes.error}>{errors[field.id]}</p>
                          )}
                        </Grid>
                      </Grid>
                      <TextValidator
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        placeholder={customizedJson.AddNewField[lang]}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            if (e.target.value && e.target.value !== "") {
                              json_schema.properties[e.target.value] = {
                                type: "text",
                                required: false,
                                listed: false,
                                searchable: false,
                                copyable: false,
                              };
                              setObject({
                                ...object,
                                [field.id]: JSON.stringify(
                                  json_schema,
                                  null,
                                  " "
                                ),
                              });
                              e.target.value = "";
                            }
                          }
                        }}
                      />
                    </div>
                  );
                }
              })}
            </div>
          </div>
          <Divider />

          {props.url !== 'json_schemas' && <div className={classes.footer}>
            <div className={classes.outlinedButtonContainer}>
              <Button
                variant="outlined"
                margin="dense"
                size="small"
                className={classes.outlinedButton}
                onClick={() => props.closeOpen(false)}
              >
                {objectForm.cancel[lang]}
              </Button>
              <Button
                variant="outlined"
                margin="dense"
                size="small"
                className={classes.filledButton}
                type="submit"
                disabled={isSubmitted}
                //onClick={() => props.objectId ?temp_status=0:temp_status=1}
                onClick={() => {props.objectId ?setReady("0"):setReady("1");
                setObject({
                  ...object,
                  change: change,
                });}}
              >
                {objectForm.save[lang]}
              </Button>
            </div>
          </div>}
          {props.url === 'json_schemas'&&confirmChange===false && <div className={classes.footer}>
            <div className={classes.outlinedButtonContainer}>
              <Button
                variant="outlined"
                margin="dense"
                size="small"
                className={classes.outlinedButton}
                onClick={() => props.closeOpen(false)}
              >
                {objectForm.cancel[lang]}
              </Button>
              <Button
                variant="outlined"
                margin="dense"
                size="small"
                className={classes.filledButton}
                type={props.objectId ?"button":"submit"}
                disabled={isSubmitted}
                //onClick={() => props.objectId ?temp_status=0:temp_status=1}
                onClick={() => {props.objectId ?setConfirmChange(true):setReady("1");
                setObject({
                  ...object,
                  change: change,
                });}}
              >
                {objectForm.save[lang]}
              </Button>
            </div>
          </div>}
          {confirmChange===true &&<div className={classes.footer}>
          <div>
            <Blink blinkTime={3} color='blue' text='This action may take a little bit longer and during this time users are not able to access the tabs which are related to this schema.
              Do you really want to proceed?' fontSize='30'>
              This action may take a little bit longer and during this time all the users will not able to access all the tabs which related to this schema.
              Do you really want to proceed?
            </Blink>
            <div className={classes.outlinedButtonContainer}>
              <Button
                variant="outlined"
                margin="dense"
                size="small"
                className={classes.outlinedButton}
                onClick={() => setConfirmChange(false)}>{objectForm.cancel[lang]}</Button>
              <Button variant="outlined"
                margin="dense"
                size="small"
                className={classes.filledButton}
                onClick={() => setReady("0")} type="submit">Confirm</Button>
            </div>
          </div>
          </div> }


        </ValidatorForm>
      </MuiPickersUtilsProvider>
    </div>
  );
};

export default ObjectForm;
